import status from '../status';

const initialState = () => ({
  features: {},
  status
});

export default initialState;
